const sourceFieldLabels: Record<string, string> = {
  workOrder: "iş emri", productCode: "ürün kodu", sku: "ürün kodu", customerCode: "müşteri",
  orderNumber: "sipariş", orderLine: "sipariş satırı", lot: "lot", lineName: "üretim hattı",
  unit: "birim", productName: "ürün adı", customerName: "müşteri adı", plannedQuantity: "üretim miktarı",
};
export function sourceMatchFields(fields: readonly string[]): string {
  return fields.map(field => sourceFieldLabels[field] ?? field).join(", ");
}
